var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.config.prefix && _vm.config.auth && _vm.config.auth.length
    ? _c(
        "div",
        { staticClass: "yxtbiz-kng-audit-content__node" },
        [
          _c("span", { staticClass: "mr12 mb12" }, [
            _vm._v(_vm._s(_vm.config.prefix)),
          ]),
          _vm._l(_vm.config.auth, function (item) {
            return _c(
              "span",
              {
                key: item.userGroupId,
                staticClass: "mr12 mb12 yxtbiz-kng-audit-content__node-item",
              },
              [
                _c("yxt-svg", {
                  staticClass: "mr4",
                  attrs: {
                    width: "16px",
                    height: "16px",
                    "icon-class": _vm.getSvgName(item),
                  },
                }),
                item.groupType === _vm.GROUP_AUTH_TYPE.DEPT
                  ? _c("yxtbiz-dept-name", {
                      attrs: { name: item.userGroupName },
                    })
                  : _c("yxtbiz-user-name", {
                      attrs: { name: item.userGroupName },
                    }),
              ],
              1
            )
          }),
          _vm.config.isChange
            ? _c(
                "yxt-tag",
                {
                  staticClass: "mr12 mb12",
                  attrs: { type: "warning", size: "mini" },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("pc_biz_kng_lbl_hadchanged" /** 已更改 */))
                  ),
                ]
              )
            : _vm._e(),
        ],
        2
      )
    : _vm.config.userName
    ? _c(
        "div",
        [
          _vm.config.userName
            ? _c("yxtbiz-user-name", { attrs: { name: _vm.config.userName } })
            : _vm._e(),
          _c("span", [_vm._v(_vm._s(_vm.config.suffix))]),
          _vm.config.isChange
            ? _c(
                "yxt-tag",
                {
                  staticClass: "ml12",
                  attrs: { type: "warning", size: "mini" },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("pc_biz_kng_lbl_hadchanged" /** 已更改 */))
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      )
    : _vm.isContentArray
    ? _c(
        "div",
        { staticClass: "yxtbiz-kng-audit-content__node" },
        [
          _vm._l(_vm.config.content, function (item, index) {
            return [
              _c(
                "yxt-tooltip",
                { key: index, attrs: { "open-filter": "", content: item } },
                [
                  _c("span", { staticClass: "mr12 mb12 ellipsis-1" }, [
                    _vm._v(_vm._s(item)),
                  ]),
                ]
              ),
            ]
          }),
          _vm.config.content.length === 0
            ? _c("span", { staticClass: "mr12 mb12" }, [_vm._v("--")])
            : _vm._e(),
          _vm.config.isChange
            ? _c(
                "yxt-tag",
                {
                  staticClass: "mr12 mb12",
                  attrs: { type: "warning", size: "mini" },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("pc_biz_kng_lbl_hadchanged" /** 已更改 */))
                  ),
                ]
              )
            : _vm._e(),
        ],
        2
      )
    : !!_vm.config.textLine
    ? _c(
        "div",
        { staticClass: "yxtbiz-kng-audit-content__ellipsis" },
        [
          _c("yxt-tooltip", { attrs: { "open-filter": "" } }, [
            _c("div", {
              staticClass: "yxtbiz-kng-audit-content__node-content",
              attrs: { slot: "content" },
              domProps: { innerHTML: _vm._s(_vm.config.content || "--") },
              slot: "content",
            }),
            _c("div", {
              staticClass: "yxtbiz-kng-audit-content__node-content",
              class: _vm.customClass,
              domProps: { innerHTML: _vm._s(_vm.config.content || "--") },
              on: { click: _vm.preview },
            }),
          ]),
          _vm.config.isChange
            ? _c(
                "yxt-tag",
                {
                  staticClass: "ml12 v-top",
                  attrs: { type: "warning", size: "mini" },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("pc_biz_kng_lbl_hadchanged" /** 已更改 */))
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      )
    : _c(
        "div",
        [
          _c("span", {
            staticClass: "yxtbiz-kng-audit-content__node-content",
            domProps: { innerHTML: _vm._s(_vm.config.content || "--") },
          }),
          _vm.config.isChange
            ? _c(
                "yxt-tag",
                {
                  staticClass: "ml12",
                  attrs: { type: "warning", size: "mini" },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("pc_biz_kng_lbl_hadchanged" /** 已更改 */))
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }